import { axios, SideNav, useEffect, useState, useNavigate, decryptData, Header, handleApiError, BreadCrumbs } from "./../MentorImport";
import AssignedCoursesTable from "./AssignedCoursesTable";
import "./AssignedCourses.css";
import "../../AdminPortal/UploadCourses/TotalUploadedCourses/TotalUploadedCourses.css";

const AssignedCourses = () => {
  const [assignedCoursesState, setAssignedCoursesState] = useState({
    tableData: [],
    orgTableData: [],
    isLoading: true,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  let parsedObject;
  const data = localStorage.getItem("userData");
  data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");

  const normalizeCourseResponse = (course) => ({
    ...course,
    id: course.id ?? course.courseId,
    title: course.title ?? course.courseTitle ?? "",
    description: course.description ?? course.courseDescription ?? "",
    userEnrolledCount: course.userEnrolledCount ?? course.totalEnrolledUser ?? 0,
    moduleCount: course.moduleCount ?? course.totalContent ?? 0,
    courseCompletionTime: course.courseCompletionTime ?? "",
    instructorList: course.instructorList ?? [],
    gradeType: course.gradeType ?? "Not Selected",
    uploadedByFirstName: course.uploadedByFirstName ?? "",
    uploadedByLastName: course.uploadedByLastName ?? "",
    createdDate: course.createdDate ?? null,
    modifiedDate: course.modifiedDate ?? null,
    isPublished: typeof course.isPublished === "boolean" ? course.isPublished : false,
    isActive: typeof course.isActive === "boolean" ? course.isActive : true,
    isAssignButtonDisabled: typeof course.isAssignButtonDisabled === "boolean" ? course.isAssignButtonDisabled : true,
    isEditButtonDisabled: typeof course.isEditButtonDisabled === "boolean" ? course.isEditButtonDisabled : true,
    isArchiveButtonDisabled: typeof course.isArchiveButtonDisabled === "boolean" ? course.isArchiveButtonDisabled : true,
  });

  const fetchAssignedCourses = async () => {
    const url = `${process.env.REACT_APP_API_URL_DOTNET}/Course/getCoursesForInstructor`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
    };

    try {
      const response = await axios.get(url, { headers });
      if (response.status === 200 || response.data.success === 200 || response.data.success === 204) {
        const normalizedCourses = (response.data.result || []).map((course) => normalizeCourseResponse(course));
        setAssignedCoursesState((prevState) => ({
          ...prevState,
          tableData: normalizedCourses,
          orgTableData: normalizedCourses,
          isLoading: false,
        }));
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      const statusCode = error.response ? error.response : null;
      handleApiError(statusCode, navigate);
    }
  };

  useEffect(() => {
    fetchAssignedCourses();
  }, []);

  useEffect(() => {
    let result = [...assignedCoursesState.orgTableData];
    if (searchQuery.trim()) {
      result = result.filter((course) => (course.title || "").toLowerCase().includes(searchQuery.toLowerCase()));
    }
    setAssignedCoursesState((prevState) => ({
      ...prevState,
      tableData: result,
    }));
  }, [searchQuery, assignedCoursesState.orgTableData]);

  return (
    <>
      <div className="assigned-courses-page">
        <div style={{ marginBottom: "3rem" }}>
          <Header />
          <SideNav />
        </div>
        <div className="container-fluid total-uploaded-courses-table-container d-flex flex-column">
          <div style={{ marginLeft: "1rem" }}>
            <div className="row">
              <div className="col-12">
                <div className="total-uploaded-courses-nav-bar">
                  <BreadCrumbs />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="total-uploaded-courses-heading">
                  <p>Assigned Courses</p>
                </div>
              </div>
            </div>

            <div className="total-uploaded-courses-filter-wrapper">
              <div className="total-uploaded-courses-search">
                <div className="total-uploaded-courses-search-icon" />
                <input
                  type="text"
                  className="total-uploaded-courses-input-bar"
                  placeholder="Search by Course Name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </div>

            <AssignedCoursesTable tableData={assignedCoursesState.tableData} isLoading={assignedCoursesState.isLoading} onActionSuccess={fetchAssignedCourses} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignedCourses;
